import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../components/Hyperlink';
import styles from './footer_copyright.module.scss';

export const FooterCopyright: FC = () => {
  return (
    <div className={styles.container}>
      <Hyperlink
        href="/e/forseti/820867877/ENT8D14971E01180556690E"
        className={styles.link}
        source="footer_static"
      >
        <FormattedMessage id="footer/components/copyright/FooterCopyright.tsx/1" />
      </Hyperlink>{' '}
      <FormattedMessage id="footer/components/copyright/FooterCopyright.tsx/2" />
    </div>
  );
};
